import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { LearninglabActivityComponent } from '@app/learning-lab/activity/activity.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import {
  CourseContentActions,
  LearninglabHeaderComponent,
  LearninglabSidebarComponent,
  MyClassService,
  VideoLectureProgress,
} from '@shared';
import { AuthenticationService } from '@shared/services/auth/authentication.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { combineLatest, distinctUntilChanged, firstValueFrom, Subscription, take } from 'rxjs';
import { CoursesService, LoaderService, LocalStorage, Logger, RouterStoreService, ToastService } from 'thkee-common';
const log = new Logger('LearninglabShellComponent');

@UntilDestroy()
@Component({
  selector: 'app-learninglab-shell',
  templateUrl: './learninglab-shell.component.html',
  styleUrls: ['./learninglab-shell.component.scss'],
  standalone: true,
  imports: [
    RouterOutlet,
    LearninglabHeaderComponent,
    LearninglabActivityComponent,
    LearninglabSidebarComponent,
    AngularSvgIconModule,
  ],
})
export class LearninglabShellComponent implements OnInit, OnDestroy {
  fullScreen: boolean = true;
  params: any = {};
  courseContentSubscription = new Subscription();
  theaterModeActionSubscription = new Subscription();
  isAuth$ = this.authService.sessionExist();
  isLogged$ = this.authService.sessionExist();

  constructor(
    private routerStore: RouterStoreService,
    private store: Store,
    private router: Router,
    private coursesService: CoursesService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private myClassService: MyClassService,
    private toastService: ToastService,
    private authService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.routerStore
      .getParams()
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe((params) => {
        this.params = params;
        // this.store.dispatch(CourseActions.loadCourse({ courseId }));
      });
    // if (Object.keys(this.params).length) {
    //   this.route.queryParams.pipe(untilDestroyed(this)).subscribe((params) => {
    //     if (params['preview'] === 'true') {
    //       this.store.dispatch(
    //         CourseContentActions.loadCourseContent({ product_id: this.params['courseId'], preview: true })
    //       );
    //       this.store.dispatch(
    //         CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'], preview: true })
    //       );
    //     } else {
    //       this.store.dispatch(CourseContentActions.loadCourseContent({ product_id: this.params['courseId'] }));
    //       this.store.dispatch(CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'] }));
    //     }
    //     this.selectActivity(this.params['section'], this.params['subsection']);
    //   });
    // }

    // combineLatest([this.routerStore.getParams(), this.routerStore.getQuery('preview')])
    //   .pipe(distinctUntilChanged(), untilDestroyed(this))
    //   .subscribe(([params, preview]) => {
    //     this.params = params;
    //     if (preview) {
    //       this.store.dispatch(
    //         CourseContentActions.loadCourseContent({ product_id: this.params['courseId'], preview: true })
    //       );
    //       this.store.dispatch(
    //         CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'], preview: true })
    //       );
    //     } else {
    //       this.store.dispatch(CourseContentActions.loadCourseContent({ product_id: this.params['courseId'] }));
    //       this.store.dispatch(CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'] }));
    //     }
    //     this.selectActivity(this.params['section'], this.params['subsection']);
    //   });

    firstValueFrom(this.routerStore.getQuery('preview')).then((preview) => {
      if (preview) {
        this.store.dispatch(
          CourseContentActions.loadCourseContent({ product_id: this.params['courseId'], preview: true })
        );
        this.store.dispatch(
          CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'], preview: true })
        );
      } else {
        this.store.dispatch(CourseContentActions.loadCourseContent({ product_id: this.params['courseId'] }));
        this.store.dispatch(CourseContentActions.loadCourseOverview({ product_id: this.params['courseId'] }));
      }
      this.selectActivity(this.params['section'], this.params['subsection']);
    });

    // Action from video js
    this.theaterModeActionSubscription.add(
      this.loaderService.response('theater-button-action').subscribe((res) => {
        res === 'loading' ? (this.fullScreen = true) : (this.fullScreen = false);
      })
    );

    // Protected route if not logged in
    combineLatest([this.routerStore.getQuery('preview'), this.isAuth$])
      .pipe(take(1))
      .subscribe(([preview, loggedIn]) => {
        if (preview && !loggedIn) {
          this.toastService.info({
            message: $localize`Login required to view preview courses. Redirecting to homepage.`,
          });
          setTimeout(() => {
            window.location.replace('/');
          }, 3000);
          return;
        }
        if (!preview && loggedIn) {
          this.myClassService.getMyClasses().subscribe((res) => {
            const isExist = res.results.find((course) => course.id === this.params['courseId']);
            if (!isExist) {
              window.location.replace(`/course/${this.params['courseId']}`);
            }
          });
        }
        if (!loggedIn) {
          window.location.replace(`/course/${this.params['courseId']}`);
        }
        // TODO: Only remain to set the condition if copy the url from preview and pest into another tab or browser
        //       where user already logged in previously
      });
  }

  ngOnDestroy(): void {
    this.courseContentSubscription.unsubscribe();
    this.theaterModeActionSubscription.unsubscribe();
  }

  intervalId: ReturnType<typeof setInterval> | undefined = undefined;
  currentTime: number = 0;
  activityHandler(event: VideoLectureProgress) {
    this.currentTime = Math.round(event.data.currentTime);
    if (event.action === 'play' && !this.intervalId) {
      LocalStorage.setText('current_video', this.params['subsection']);
      this.intervalId = setInterval(() => {
        // this.saveVideoPosition(this.currentTime);
        this.saveVideoPositionLocalStorage(this.currentTime.toString());
      }, 3000);
    }
    if (event.action === 'pause' || event.action === 'ended') {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    }
    if (event.action === 'pause') {
      this.saveVideoPositionLocalStorage(this.currentTime.toString());
    }

    if (event.action == 'full-screen') {
      this.fullScreen = !this.fullScreen;
    }
  }

  saveVideoPositionLocalStorage(duration: string) {
    const current_subsection = LocalStorage.getText('current_video');

    if (current_subsection === this.params['subsection']) {
      LocalStorage.setText('current_video_position', duration);
    } else {
      LocalStorage.removeStorageItem('current_video_position');
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    }
  }

  // saveVideoPosition(duration: number) {
  //   firstValueFrom(this.store.select(selectActiveSubsection)).then((subs) => {
  //     if (this.params['overviewcode'] && subs?.type === 'lecture' && subs.lecture?.type === 'video') {
  //       this.myClassService
  //         .markedAsRead({ subsection: subs?.id ?? '', watched_duration: duration }, this.params['overviewcode'])
  //         .pipe(distinctUntilChanged(), untilDestroyed(this))
  //         .subscribe({
  //           next: (res) => {},
  //           error: ({ error }) => {
  //             this.toastService.error({
  //               message: error.error,
  //             });
  //           },
  //         });
  //     } else {
  //       if (this.intervalId) {
  //         clearInterval(this.intervalId);
  //         this.intervalId = undefined;
  //       }
  //     }
  //   });
  // }

  selectActivity(sectionId: string, subsectionId: string) {
    this.store.dispatch(
      CourseContentActions.selectActivity({
        sectionId,
        subsectionId,
      })
    );
  }

  // Reload
  reload() {
    let url = `/learning-lab/${this.params['courseId']}/overview/${this.params['section']}/${this.params['subsection']}`;
    this.router.navigateByUrl(url, { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  }
}
